

export const URL_SERVER = "https://apiweb.codesign.mx";
